import { render, staticRenderFns } from "./SaudiAccounts.vue?vue&type=template&id=5f88c9b0&scoped=true&lang=pug"
import script from "./SaudiAccounts.vue?vue&type=script&lang=js"
export * from "./SaudiAccounts.vue?vue&type=script&lang=js"
import style0 from "./SaudiAccounts.vue?vue&type=style&index=0&id=5f88c9b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88c9b0",
  null
  
)

export default component.exports